<template>
     <h5>Authenticated
        <ProgressBar :disabled="isAnonymous" :percent="percent" />
     </h5>
</template>
<script>
import { mapGetters } from 'vuex';
    
import ProgressBar from '@/components/ProgressBar';
export default {
    name: "ProgressBarAuthenticated",
    components: {
        ProgressBar,
    },
    computed: {
       percent() {
            return this.isAuthenticated ? 100 : 0;
        },
        ...mapGetters({
            isAnonymous: 'isAnonymous',
            isAuthenticated: 'isAuthenticated',
        }),
    }
}
</script>
<style>

</style>